<template>
<div class="container">

    <header class="jumbotron">
        <div class="columns">
            <span class="column is-full global-message" v-for="(message, index) in messages" :key="index" :class="message.seen ? 'grey-message' : 'blue-message'">
                <span v-html="message.message"></span>
                <p class="global-message-author" :class="message.old ? 'old' : ''">{{ message.user.username }} on {{ formatDate(message.updatedAt) }} </p>
                <b-icon v-if="isAdmin || (isManagement || isManager) && matchUserId(message.userId)" @click.native.prevent="deleteMessage(message.id)" icon="delete-outline" type="is-danger" size="is-small" class="icon-delete-message"></b-icon>
            </span>
        </div>
        <div class="columns center-allign" v-if="isManagement || isManager">

            <b-field label="Global Message" class="column is-two-third">
                <vue-editor v-model="global_message"></vue-editor>
            </b-field>
            <b-icon style="cursor: pointer; margin-left: 12px;" @click.native.prevent="createMessage()" icon="send-circle" type="is-success" size="is-medium"></b-icon>

        </div>
    </header>
</div>
</template>

<script>
import UserService from '../services/user.service';
import UtilService from '../services/util'

import {
    VueEditor
} from "vue2-editor";

export default {
    name: 'Home',
    data() {
        return {
            content: '',
            global_message: '',
            messages: [],
            lastMessageSeenAt: null
        };
    },
    components: {
        VueEditor,
    },
    created() {
        if (this.currentUser.templateOptions && Object.keys(this.currentUser.templateOptions).length) {
            if (this.currentUser.templateOptions.lastMessageSeenAt) {
                this.lastMessageSeenAt = this.currentUser.templateOptions.lastMessageSeenAt
            }
        }
    },
    mounted() {
        UserService.getPublicContent().then(
            response => {
                this.content = response.data;
                this.getMessage()
            },
            error => {
                this.content =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
            }
        );
    },
    computed: {
        isManagement() {
            return UtilService.isManagement()
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        isManager() {
            return UtilService.isManager()
        },
        isAdmin() {
            return UtilService.isAdmin()
        },
    },
    methods: {
        matchUserId(userId) {
            return UtilService.matchUserId(userId)
        },
        getMessage() {
            UserService.getMessages().then((response) => {
                if(!response.data.length) {
                    return
                }
                this.messages = response.data.sort((a, b) => {
                    return new Date(b.updatedAt) - new Date(a.updatedAt)
                }).map(message => {
                    return {
                        ...message,
                        seen: this.lastMessageSeenAt ? new Date(message.updatedAt) <= new Date(this.lastMessageSeenAt) : false,
                        old: this.messageIsOld(message.updatedAt)
                    }
                })

                const lastMessageSeenAt = this.messages ? this.messages[0].updatedAt : null
                if (lastMessageSeenAt && lastMessageSeenAt !== this.lastMessageSeenAt) {
                    this.lastMessageSeenAt = lastMessageSeenAt
                    this.storeUserData()
                }
            })
        },
        createMessage() {
            UserService.createMessage({
                userId: this.currentUser.id,
                message: this.global_message
            }).then(() => {
                this.global_message = ''
                this.getMessage()
            })
        },
        deleteMessage(id) {
            UserService.deleteMessage(id).then(() => {
                this.getMessage()
            })
        },
        messageIsOld(addData) {
            const magicNumber = 60
            return Math.ceil(Math.abs(new Date() - new Date(addData)) / (1000 * 60 * 60 * 24)) > magicNumber
        },
        storeUserData() {
            if(this.currentUser && this.currentUser.templateOptions) {
                const templateOptions = {
                    ...this.currentUser.templateOptions,
                    lastMessageSeenAt: this.lastMessageSeenAt
                }

                UserService.updatePersonalInformation({
                    id: this.currentUser.id,
                    templateOptions: JSON.stringify(templateOptions)
                });
                this.$store.dispatch('auth/setUserTemplateOptions', templateOptions);
            }
        },
        formatDate(dateString) {
            return new Intl.DateTimeFormat("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            }).format(new Date(dateString));
        }
    }
};
</script>

<style>
.global-message {
    border: 1px solid #bfb3b3;
    border-radius: 8px;
    position: relative;
    margin-bottom: 15px;
}

.global-message .global-message-author {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 10px;
    color: grey;
}

.global-message .icon-delete-message {
    position: absolute;
    right: 6px;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
}

.columns.center-allign {
    align-items: center;
}

.global-message-author.old {
    color: #FF6758;
}
</style>
